import React from "react"
import {
  Heading as HeadingChakra,
  HeadingProps as HeadingChakraProps,
} from "@chakra-ui/react"
import { motion, HTMLMotionProps } from "framer-motion"

export type SubHeadingType = "medium" | "small"

type FramerMotionProps = HTMLMotionProps<"h3"> | HTMLMotionProps<"h4">

type CustomHeadingProps = {
  /**
   * defines the styles to be displayed
   */
  type: SubHeadingType
}

export type SubHeadingProps = CustomHeadingProps &
  HeadingChakraProps &
  FramerMotionProps

const ChakraHeadingWithMotion = motion(HeadingChakra)

export const SubHeading: React.FC<SubHeadingProps> = ({
  children,
  type,
  color,
  ...props
}) => {
  switch (type) {
    case "medium":
      return (
        <ChakraHeadingWithMotion
          lineHeight="subHeading"
          as="h3"
          fontSize="subHeading.medium"
          color={color}
          {...props}
        >
          {children}
        </ChakraHeadingWithMotion>
      )
    case "small":
      return (
        <ChakraHeadingWithMotion
          lineHeight="subHeading"
          as="h4"
          fontSize="subHeading.medium"
          color={color}
          {...props}
        >
          {children}
        </ChakraHeadingWithMotion>
      )

    default:
      return (
        <ChakraHeadingWithMotion {...props}>{children}</ChakraHeadingWithMotion>
      )
  }
}
